module.exports = __webpack_public_path__ + "media/images/illustrations/flat_town-c9c79f0fd9e01c6493c07188cb7e4ec3.svg";